/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { removeRxDatabase } from 'rxdb';
import { RxdbAdaptorProvider } from '../../infrastructure/rxdb-adaptor.provider';

declare let cordova: any;
@Injectable()
export class DatabaseManagerService {
	public constructor(private adapterProvider: RxdbAdaptorProvider) {}

	public async deleteWorkfile(workfileId: string): Promise<void> {
		try {
			const adapter = this.adapterProvider.getAdaptor();
			await removeRxDatabase(workfileId, adapter);
		} catch {
			throw new Error('Delete workfile (database) failed');
		}
	}

	public async clearWorkfileConnections(workfileId: string): Promise<boolean> {
		return new Promise((resolve, reject) => {
			cordova.exec(
				(_) => {
					resolve(true);
				},
				(_) => {
					reject(false);
				},
				'SQLitePlugin',
				'closeSqlLiteConnections',
				[
					{
						databaseName: workfileId
					}
				]
			);
		});
	}
}
